import HeroDetail from '../hero-detail';
import type { HeroDetailTemplateProps } from './types';

export default function ArcanatacticsHeroDetailTemplate(
  props: HeroDetailTemplateProps,
) {
  return (
    <HeroDetail
      hero={props.hero}
      directory={props.directory}
      startAtContent={props.startAtContent}
      initialContentSection={props.initialContentSection}
      initialSectionOffset={props.initialSectionOffset}
      onOpenHeroDirectory={props.onOpenHeroDirectory}
      onNavigateHero={props.onNavigateHero}
    />
  );
}
